import { divIcon } from "leaflet";
import stringUtilities from "../../../utilities/stringUtilities";

export const getTextMarkerIcon = (id, text, color, fontsize, rotate, width) => divIcon({
    html: `<div id="${ id }" class="text-overlay ${ !stringUtilities.isNullOrEmpty(fontsize) ? fontsize : "" } ${ (width && width > 0) ? "has-width" : "" }" style="${ (width && width > 0) ? `width: ${ width }px;` : "" } transform: translate(-50%, -50%) rotate(${ rotate ?? 0 }deg); ${ !stringUtilities.isNullOrEmpty(color) ? `color: ${ color };` : "" }">${ (stringUtilities.isNullOrEmpty(text) ? "Add Note" : text) }</div>`,
    className: "marker-icon-text-overlay",
    iconAnchor: [0, 0]
});